import { auditService } from "@/stores/services/auditService";
import { skipToken } from "@reduxjs/toolkit/query";

export function useDriverData(companyId: number, auditId?: number) {
  const { data: driverByCompanyid, isFetching: isLoadingDriverByCompany } =
    auditService.useFindDriversByCompanyIdQuery(
      auditId && auditId > 0 ? { companyId, auditId } : skipToken,
    );

  return {
    driverByCompanyid,
    isLoadingDriverByCompany,
  };
}
